import { useEffect, useState } from "react";
import { Redirect, Route, Switch, useLocation } from "react-router-dom";
import ChecklistMonitor from "../routes/ChecklistMonitor/ChecklistMonitor";
import EditChecklist from "../routes/EditChecklist/EditChecklistPresentational";
import EvaluateChecklist from "../routes/EvaluateChecklist/EvaluateChecklist";
import NewChecklist from "../routes/Form/NewChecklist";
import EditEvaluatedChecklist from "../routes/Form/EditEvaluatedChecklist";
import Header from "../components/Header/Header";
import HomePage from "../routes/HomePage/HomePage";
import NewOperationalArea from '../routes/OperationalAreaPages/NewOperationalArea';
import EditOperationalArea from '../routes/OperationalAreaPages/EditOperationalArea';

import styles from "./MainContainer.module.css";
import TabLabel from "../components/controls/TabLabel/TabLabel";
import { set } from "date-fns/esm";
import CssLoader from "../components/controls/CssLoader/CssLoader";
import ViewChecklist from "../routes/ViewChecklist/ViewChecklist";

import { loggedInValue, isSuperuserValue } from '../access/access';
import OperationalAreaManagement from "../routes/OperationalAreaPages/OperationalAreaManagement";
import LoginErrorElement from "../errorHandling/LoginErrorElement";
import CompanyManagement from "../routes/CompanyManagementPages/CompanyManagement";
import NewCompany from "../routes/CompanyManagementPages/NewCompany";
import EditCompany from "../routes/CompanyManagementPages/EditCompany";
import SubsidiaryManagement from "../routes/SubsidiaryManagementPages/SubsidiaryManagement";
import NewSubsidiary from "../routes/SubsidiaryManagementPages/NewSubsidiary";
import EditSubsidiary from "../routes/SubsidiaryManagementPages/EditSubsidiary";
import EditNewChecklist from "../routes/Form/EditNewChecklist";
import NotificationElement from "../errorHandling/NotificationElement";
import TemplateMonitor from "../routes/TemplateMonitor/TemplateMonitorPresentational";
import AssessmentManager from "../routes/AssessmentManager/AssessmentManager";
import AssessmentManagerOverride from "../routes/AssessmentManager/AssessmentManagerOverride";
import OverrideManager from "../routes/Override/OverrideManager";

const MainContainer = (props) => {
  const [isLoggedIn, setIsLoggedIn] = useState(loggedInValue()); // custom hook
  const [isSuperuser, setIsSuperuser] = useState(isSuperuserValue());

  // const isSuperuser = useSelector(state => state.isSuperuser);
  const [headerLabel, setHeaderLabel] = useState();
  const [tabLabel, setTabLabel] = useState("Intelligent Audit Platform");
  const [moreWidth, setMoreWidth] = useState("");
  const [isHomepage, setIsHomepage] = useState();
  const [pageMightNeedSave, setPageMightNeedSave] = useState();
  const [isEditChecklist, setIsEditChecklist] = useState(false);

  // get current location (from react-router-dom) package
  let location = useLocation();

  console.log("location.pathname: ", location.pathname);

  useEffect(() => {
    if (loggedInValue()) {
      console.log("sessionStorage: ", sessionStorage)
      setIsLoggedIn(loggedInValue());
      setIsSuperuser(isSuperuserValue());
    }
  }, [props.initialApiCallFinished]);

  useEffect(() => {

    if (!isLoggedIn) {
      setHeaderLabel("Please wait...")
    }
    if (isLoggedIn) {
      switch (location.pathname) {
        case "/home":
          configureSelectedPageInformation("Home", "Internal Control System", "", "home", true, false, false);
          break;
        case "/edit-new-checklist":
          configureSelectedPageInformation("Edit Checklist", "Insert/Edit Information", "", "edit new checklist", false, true, false);
          break;
        case "/new-checklist":
          configureSelectedPageInformation("New Checklist", "Insert/Edit Information", "", "new checklist", false, true, false);
          break;
        case "/edit-evaluated-checklist":
          configureSelectedPageInformation("Edit Checklist", "Edit Checklist Information", "", "edit evaluated checklist", false, true, false);
          break;
        case "/edit-checklist":
          configureSelectedPageInformation("Edit Checklist", null, "extraWidth", "edit checklist", false, true, true);
          break;
        case "/evaluate-checklist":
          configureSelectedPageInformation("Evaluate Checklist", null, "extraWidth", "evaluate checklist", false, true, false);
          break;
        case "/view-checklist":
          configureSelectedPageInformation("View Checklist", null, "extraWidth", "view checklist", false, false, false);
          break;
        case "/checklist-monitor":
          configureSelectedPageInformation("Checklist Monitor", "Checklist Management", "extraWidth", "checklist monitor", false, false, false);
          break;
        case "/operational-area-monitor":
          configureSelectedPageInformation("Operational Area Monitor", "Operational Area Management", "", "operational area monitor", false, false, false);
          break;
        case "/new-operational-area":
          configureSelectedPageInformation("New Operational Area", "Internal Control System", "", "new operational area", false, true, false);
          break;
        case "/edit-operational-area":
          configureSelectedPageInformation("Edit Operational Area", "Internal Control System", "", "edit operational area", false, true, false);
          break;
        case "/company-monitor":
          configureSelectedPageInformation("Company Monitor", "Company Management", "", "company monitor", false, false, false);
          break;
        case "/new-company":
          configureSelectedPageInformation("New Company", "Internal Control System", "", "new company", false, true, false);
          break;
        case "/edit-company":
          configureSelectedPageInformation("Edit Company", "Internal Control System", "", "edit company", false, true, false);
          break;
        case "/subsidiary-monitor":
          configureSelectedPageInformation("Subsidiary Monitor", "Subsidiary Management", "", "subsidiary monitor", false, false, false);
          break;
        case "/new-subsidiary":
          configureSelectedPageInformation("New Subsidiary", "Internal Control System", "", "new subsidiary", false, true, false);
          break;
        case "/edit-subsidiary":
          configureSelectedPageInformation("Edit Subsidiary", "Internal Control System", "", "edit subsidiary", false, true, false);
          break;
        case "/template-monitor":
          configureSelectedPageInformation("Edit Framework's Questions", "Internal Control System", "extraWidth", "template monitor", false, true, false);
          break;
        case "/override-manager":
          configureSelectedPageInformation("Override Manager", "Override Management", "", "override manager", false, false, false);
          break;
        case "/override-manager/override": 
          configureSelectedPageInformation("Override Manager", "Override Management", "", "override manager", false, false, false);
          break;
        case "/assessment-manager":
          configureSelectedPageInformation("Assessment Manager", "Assessment Management", "", "assessment manager", false, false, false);
          break;
        case "/assessment-manager/override":
          configureSelectedPageInformation("Assessment Manager Override", "Assessment Management Override", "", "assessment manager override", false, false, false);
          break;
        default:
          configureSelectedPageInformation("Home", "Internal Control System", "", "default", true, false, false);
      }
    }
    console.log("useEffect, mainContainer")
  }, [location]); // location

  const configureSelectedPageInformation = (headerLabelValue, tabLabelValue, moreWidthValue, textToLog, isHomePageValue, pageSaveValue, isEditChecklistValue) => {
    console.log(textToLog);
    if (headerLabelValue) {
      setHeaderLabel(headerLabelValue);
    }
    if (tabLabelValue) {
      setTabLabel(tabLabelValue);
    } else {
      setTabLabel("")
    }
    setMoreWidth(moreWidthValue);
    if (isHomePageValue !== undefined) {
      setIsHomepage(isHomePageValue); // required to display the Log Off button (if it is included) when in homepage
    }
    if (pageSaveValue !== undefined) {
      setPageMightNeedSave(pageSaveValue)
    }
    if (isEditChecklistValue !== undefined) {
      setIsEditChecklist(isEditChecklistValue)
    }
  }

  const checklistNameHandler = (title) => {
    setTabLabel(title);
  }

  let containerStyle = "mainContainer";
  let header_checkMonitor = "";
  let alignItems = "align-items-center";

  if (location.pathname.startsWith("/checklist-monitor")) {
    // containerStyle = "mainContainer-4xl";
    header_checkMonitor = "header_checkMon";
    alignItems = "align-items-start";
  } else if (location.pathname.startsWith("/new-operational-area") ||
    location.pathname.startsWith("/edit-operational-area") ||
    location.pathname.startsWith("/new-company") ||
    location.pathname.startsWith("/edit-company") ||
    location.pathname.startsWith("/new-subsidiary") ||
    location.pathname.startsWith("/edit-subsidiary")) {
    containerStyle = "operationalArea"
  } else if (location.pathname.startsWith("/operational-area-monitor")) {
    containerStyle = "operationalAreaMonitor"
  }

  console.log(`sessionStorage.getItem("loggedIn"): `, loggedInValue())

  let isExpiredPath = (location.pathname).startsWith('/expired');
  let isLoginErrorPath = (location.pathname + location.search).startsWith('/login?error=1');
  // console.log("isExpiredPath: ", isExpiredPath)

  return (
    <div className={`${styles.outerDiv} position-relative ${"d-flex justify-content-center"} ${alignItems}`}>
      {isExpiredPath && <NotificationElement message={"This session has expired (possibly due to multiple simultaneous logins as the same user)."} />}
      {isLoginErrorPath && <LoginErrorElement />}
      {!loggedInValue() && !isLoginErrorPath && !isExpiredPath &&
        <Switch>
          <Route path="/">
            <CssLoader />
          </Route>
        </Switch>}
      {loggedInValue() && !isExpiredPath && !isLoginErrorPath &&
        <div className={`${styles[containerStyle]} ${styles[moreWidth]} p-3 pt-0`} >
          <div className={`${styles.header} ${styles[header_checkMonitor]}`}>
            <Header isHomepage={isHomepage} isEditChecklist={isEditChecklist} pageNeedsSave={pageMightNeedSave}>{headerLabel}</Header>
            {/* {!location.pathname.startsWith("/template-monitor") && <TabLabel>{tabLabel}</TabLabel>} */}
            <TabLabel>{tabLabel}</TabLabel>
          </div>
          <Switch>
            <Route path="/home">
              <HomePage initialApiCallFinished={props.initialApiCallFinished} />
            </Route>
            <Route path="/new-checklist">
              {isSuperuser ? <NewChecklist /> : <Redirect to="/home" /> /* if the path is manually typed, the user will still be redirected to the home page */}
            </Route>
            <Route path="/edit-new-checklist">
              {isSuperuser ? <EditNewChecklist /> : <Redirect to="/home" /> /* if the path is manually typed, the user will still be redirected to the home page */}
            </Route>
            <Route path="/edit-checklist">
              {isSuperuser ? <EditChecklist setChecklistName={checklistNameHandler} /> : <Redirect to="/home" />}
            </Route>
            <Route path="/evaluate-checklist">
              <EvaluateChecklist setChecklistName={checklistNameHandler} />
            </Route>
            <Route path="/edit-evaluated-checklist">
              {isSuperuser ? <EditEvaluatedChecklist /> : <Redirect to="/home" /> /* if the path is manually typed, the user will still be redirected to the home page */}
            </Route>
            <Route path="/view-checklist">
              <ViewChecklist setChecklistName={checklistNameHandler} />
            </Route>
            <Route path="/checklist-monitor">
              <ChecklistMonitor />
            </Route>
            <Route path="/operational-area-monitor">
              {isSuperuser ? <OperationalAreaManagement /> : <Redirect to="/home" />}
            </Route>
            <Route path="/new-operational-area">
              {isSuperuser ? <NewOperationalArea /> : <Redirect to="/home" />}
            </Route>
            <Route path="/edit-operational-area">
              {isSuperuser ? <EditOperationalArea /> : <Redirect to="/home" />}
            </Route>
            <Route path="/company-monitor">
              {isSuperuser ? <CompanyManagement /> : <Redirect to="/home" />}
            </Route>
            <Route path="/new-company">
              {isSuperuser ? <NewCompany /> : <Redirect to="/home" />}
            </Route>
            <Route path="/edit-company">
              {isSuperuser ? <EditCompany /> : <Redirect to="/home" />}
            </Route>
            <Route path="/subsidiary-monitor">
              {isSuperuser ? <SubsidiaryManagement /> : <Redirect to="/home" />}
            </Route>
            <Route path="/new-subsidiary">
              {isSuperuser ? <NewSubsidiary /> : <Redirect to="/home" />}
            </Route>
            <Route path="/edit-subsidiary">
              {isSuperuser ? <EditSubsidiary /> : <Redirect to="/home" />}
            </Route>
            <Route path="/template-monitor">
              {isSuperuser ? <TemplateMonitor /> : <Redirect to="/home" />}
            </Route>
             <Route path="/override-manager/override">
              <AssessmentManagerOverride />
            </Route>
            <Route path="/override-manager">
              <OverrideManager />
            </Route>
           { /*
            <Route path="/assessment-manager/override">
              {isSuperuser ? <AssessmentManagerOverride /> : <Redirect to="/home" />}
            </Route>
            */
            }
            <Route path="/assessment-manager">
              {isSuperuser ? <AssessmentManager /> : <Redirect to="/home" />}
            </Route>

            <Route path="/">
              <Redirect to="/home" />
            </Route>
          </Switch>
        </div>
      }
    </div>
  );
};

export default MainContainer;
